import { render } from "./FormButton.vue?vue&type=template&id=1e914bfa&scoped=true"
import script from "./FormButton.vue?vue&type=script&lang=js"
export * from "./FormButton.vue?vue&type=script&lang=js"

import "./FormButton.vue?vue&type=style&index=0&id=1e914bfa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e914bfa"

export default script